<div class="row notification {{ type }} {{ exit ? '' : 'pl-0' }}" *ngIf="show" id="{{ id }}">
  <div class="col-1 icon">
    <img [src]="srcIcon" *ngIf="customIcon" >
    <img *ngIf="!customIcon" [src]="type === 'success' || type === 'success-inline' ? iconSuccess :
            type === 'error'   || type === 'error-inline'   ? iconError :
            type === 'info'    || type === 'info-inline'    ? iconInfo :
            type === 'warning' || type === 'warning-inline' ? iconWarning :
            ''" alt="icon" class="">
  </div>
  <div class="{{ exit ? 'col-10' : 'col-11' }} content" id="{{idMessage}}">
    <span> {{ message }} <u><span *ngIf="hyperlinkText" class="hyperlink-text"
          (click)="clickHyperlink()">{{ hyperlinkText }}</span></u></span>
  </div>
  <div class="col-1 icon-exit" *ngIf="exit" id="close">
    <img [src]="xIcon" alt="icon" (click)="closeNotification()">
  </div>

  <div class="col-12 container-list" *ngIf="list.length > 0">
    <ul *ngFor="let error of list; let i = index">
      <li id="Economic_Group_Error_{{i}}">
        {{error.message}}
      </li>
    </ul>
  </div>
</div>
